// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"Notification_alertWrapper__3QN0x","alertTitle":"Notification_alertTitle__uQUpv"};